let component = {
    api: null
}
component.setClientAPI = (c) =>  { component.api = c }


component.loadResources = (www_root, cssFiles, jsfiles, callback) => {

    // window.console.log('loadResources>', entornoActivo, www_root, www_root, www_root)
    if (!www_root.endsWith('/')) www_root = www_root + '/'

    for (var csf in cssFiles) {
        component.loadCss(www_root + cssFiles[csf]);
    }

    for (var jsf in jsfiles) {
        const f = jsfiles[jsf]
        const path = f.startsWith('/') ? f : (www_root + f)
        // console.log('loadResources', {f, path})
        component.loadJS(path, false, callback, jsfiles.length);
    }
}

component.loadCss = (url) => {
    var filename = url.substring(url.lastIndexOf('/') + 1);

    document.getElementsByTagName('head')[0].insertAdjacentHTML('beforeend', `<link rel="stylesheet" href="${url}" id="${filename}"/>`);
}

component.loaded = 0

component.loadJS = (url, async, onloadedCallback, totalFiles) => {
    onloadedCallback = onloadedCallback || ((url) => { window.console.log('fichero js cargado>', url) })

    // window.console.log('wloadJS>', url)

    var scriptTag = document.createElement('script');
    scriptTag.src = url;
    scriptTag.async = async;

    // onloadedCallback;
    scriptTag.onload = function () {
        component.loaded = component.loaded + 1
        // window.console.log({ loaded: component.loaded, totalFiles, remaining: totalFiles - component.loaded })
        if (+component.loaded === +totalFiles) {
            onloadedCallback(url)
            component.loaded = 0
        }
    }
    scriptTag.onreadystatechange = onloadedCallback;
    // scriptTag.setAttribute("async", false);
    // window.console.log('Cargando ', scriptTag)

    // document.body.appendChild(scriptTag);
    document.getElementsByTagName('head')[0].appendChild(scriptTag)
}

export default component;